import { render, staticRenderFns } from "./ProTag.vue?vue&type=template&id=5bad0e5f"
import script from "./ProTag.vue?vue&type=script&lang=js"
export * from "./ProTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5bad0e5f')) {
      api.createRecord('5bad0e5f', component.options)
    } else {
      api.reload('5bad0e5f', component.options)
    }
    module.hot.accept("./ProTag.vue?vue&type=template&id=5bad0e5f", function () {
      api.rerender('5bad0e5f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "static/js/components-wa/messages/ProTag.vue"
export default component.exports